import { render, staticRenderFns } from "./gewerke.vue?vue&type=template&id=1d7ed757&"
import script from "./gewerke.vue?vue&type=script&lang=js&"
export * from "./gewerke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports